export const NewspaperIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12856_18775)">
      <path d="M20 0H0V20H20V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M8.75004 18.3333L8.33337 15"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 18.3333V5H10.4167L10.8333 8.33333L11.25 11.6667L11.6667 15L8.75 18.3333H18.3333Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.25 11.668H14.5833" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.8334 8.33203H14.5834" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.66663 1.66797H9.99996L10.4166 5.0013L10.8333 8.33464L11.25 11.668L11.6666 15.0013H8.33329H1.66663V1.66797Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.16663 5H7.08329" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.16663 8.33203H7.49996" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.16663 11.668H7.91663" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_12856_18775">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
